import { notFoundSVGIcon } from './common';
import { SVGIconDetail, SVGIconWithoutValue, createSVGPath } from './icons';
import { getNumericObjectValues } from '../../../core/utils/general/general';

const packedIconDetail = (): SVGIconWithoutValue => ({
  viewBoxSize: 16,
  shapes: [
    createSVGPath(
      'M14.12 4 8.62.85a1.28 1.28 0 0 0-1.24 0L1.88 4a1.25 1.25 0 0 0-.63 1.09V11a1.25 1.25 0 0 0 .63 1l5.5 3.11a1.28 1.28 0 0 0 1.24 0l5.5-3.11a1.25 1.25 0 0 0 .63-1V5.05A1.25 1.25 0 0 0 14.12 4zm-6.74 9.71-2.13-1.2v-5.3l2.13 1.16zM8 7.29 5.92 6.15l4.81-2.67 2.09 1.18zm0-5.35 1.46.82-4.84 2.69-1.44-.79zM2.5 5.71l1.5.82v5.27L2.5 11zm6.12 8V8.37l4.88-2.66V11z'
    ),
  ],
});

const inTransitIconDetail = (): SVGIconWithoutValue => ({
  viewBoxSize: 50,
  shapes: [
    createSVGPath(
      'M10 3L10 13L20 13L20 3L10 3 z M 33 13L33 27L1 27C0.447 27 0 27.448 0 28L0 34C0 36.206 1.794 38 4 38L8.0898438 38C8.5678437 40.833 11.032 43 14 43C16.968 43 19.431156 40.833 19.910156 38L33 38C33.48 40.832 36.031 43 39 43C41.969 43 44.43025 40.832 44.90625 38L47 38C48.57 38 50 36.57 50 35L50 25.375C50 23.363 48.551 21.3085 48.375 21.0625L44.21875 15.5C43.26575 14.352 41.77 13 40 13L33 13 z M 4 15L4 25L14 25L14 15L4 15 z M 16 15L16 25L26 25L26 15L16 15 z M 38 18L43.59375 18L46.78125 22.25C47.12025 22.73 48 24.203 48 25.375L48 26L38 26C37 26 36 25 36 24L36 20C36 18.895 37 18 38 18 z M 14 33C16.206 33 18 34.794 18 37C18 39.206 16.206 41 14 41C11.794 41 10 39.206 10 37C10 34.794 11.794 33 14 33 z M 39 33C41.207 33 43 34.793 43 37C43 39.207 41.207 41 39 41C36.793 41 35 39.207 35 37C35 34.793 36.793 33 39 33 z'
    ),
  ],
});

const deliveredIconDetail = (): SVGIconWithoutValue => ({
  viewBoxSize: 612,
  shapes: [
    createSVGPath(
      'M580.592,135.703L497.33,98.681L234.478,222.254v79.353l-45.854-20.389v-79.353L451.477,78.293l-88.287-39.256 c-11.822-5.256-31.166-5.256-42.987,0l-217.401,96.666c-17.319,7.701-31.453,29.51-31.409,48.464l0.339,143.238 c13.628-4.385,28.128-6.806,43.195-6.806c77.949,0,141.373,63.424,141.373,141.382c0,20.36-4.413,39.682-12.196,57.188 l76.764,32.815c11.436,4.888,30.146,4.889,41.583,0.002l216.905-92.694c17.614-7.527,32.062-29.357,32.107-48.513L612,184.166 C612.044,165.212,597.911,143.403,580.592,135.703z M496.655,300.16l29.458-62.149c2.974-6.273,10.429-9.892,13.413-6.49 l30.229,34.461c3.019,3.441-0.812,11.277-6.869,14.087l-12.724,5.903l-0.257,89.528c-0.012,3.912-3.467,8.569-7.708,10.399 l-19.049,8.223c-4.176,1.803-7.554,0.132-7.556-3.729l-0.064-88.354l-12.325,5.718C497.407,310.446,493.778,306.23,496.655,300.16z M388.039,350.943l26.773-59.078c2.7-5.959,9.604-9.312,12.422-6.012l28.532,33.423c2.85,3.336-0.628,10.779-6.237,13.381 l-11.782,5.466l0.76,85.727c0.033,3.749-3.135,8.163-7.066,9.86l-17.664,7.625c-3.873,1.672-7.042,0.025-7.087-3.675l-1.035-84.647 l-11.429,5.302C388.852,360.808,385.422,356.718,388.039,350.943z M583.911,399.271c-0.014,1.967-1.781,4.298-3.946,5.208 l-201.751,84.757c-1.883,0.791-3.432-0.037-3.459-1.851l-0.155-9.861c-0.028-1.817,1.476-3.942,3.361-4.745l202.111-86.097 c2.17-0.924,3.92-0.075,3.908,1.896L583.911,399.271z M114.925,347.054C51.454,347.054,0,398.508,0,461.979 c0,63.472,51.454,114.926,114.925,114.926s114.925-51.454,114.925-114.926C229.851,398.508,178.396,347.054,114.925,347.054z M190.021,438.367l-70.724,79.563c-3.484,3.919-8.335,5.932-13.221,5.932c-3.881,0-7.783-1.27-11.038-3.877l-44.202-35.361 c-7.624-6.095-8.862-17.223-2.759-24.846c6.095-7.632,17.228-8.867,24.851-2.763l31.093,24.872l59.574-67.02 c6.479-7.295,17.659-7.959,24.958-1.468C195.853,419.893,196.509,431.063,190.021,438.367z'
    ),
  ],
});

const returnedIconDetail = (): SVGIconWithoutValue => ({
  viewBoxSize: 512,
  shapes: [
    createSVGPath(
      'M489.121,100h-248.4c-12.641,0-22.881,10.24-22.881,22.88v246.56h118.468l0.733,0.002v-0.002h0.24 c0-3.84,0.318-7.6,0.959-10.88c5.199-30,31.199-51.84,61.68-51.84c30.48,0,56.48,21.84,61.68,51.6 c0.641,3.52,0.961,7.28,0.961,11.12h30.879c10.24,0,18.56-8.32,18.56-18.64V122.88C512,110.24,501.76,100,489.121,100z M464,160v32 H272v-32H464z M272,224h192v32H272V224z'
    ),
    createSVGPath(
      'M39.359,152.56L0,265.44v104h39.992l0.248,0.002v-0.002h0.24c0-3.84,0.32-7.6,0.959-10.88 c5.281-30,31.201-51.84,61.682-51.84c30.478,0,56.478,21.84,61.68,51.6c0.639,3.36,0.959,6.96,0.959,11.12h33.041V138H61.039 C51.52,138,42.961,143.76,39.359,152.56z M169.121,245.2c0,5.6-4.48,10-10.082,10H50.721c-7.121,0-12-7.2-9.281-13.76L62.801,174 c1.52-3.76,5.199-6.24,9.279-6.24h86.959c5.602,0,10.082,4.48,10.082,10V245.2z'
    ),
    createSVGPath(
      'M103.121,326.72c-20.961,0-38.48,15.28-41.922,35.28c-0.478,2.32-0.719,4.88-0.719,7.44 c0,23.44,19.119,42.56,42.641,42.56c23.6,0,42.638-19.12,42.638-42.56c0-2.56-0.16-5.12-0.638-7.44 C141.68,342,124.16,326.72,103.121,326.72z'
    ),
    createSVGPath(
      'M399.92,326.72c-21.041,0-38.48,15.28-42,35.28c-0.4,2.32-0.639,4.88-0.639,7.44 c0,23.44,19.119,42.56,42.639,42.56c23.6,0,42.64-19.12,42.64-42.56c0-2.56-0.16-5.12-0.64-7.44 C438.4,342,420.961,326.72,399.92,326.72z'
    ),
  ],
});

export const cancelledIconDetail = (): SVGIconWithoutValue => ({
  viewBoxSize: 24,
  shapes: [
    createSVGPath(
      'M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12ZM16.1716 14.7574C16.6951 13.967 17 13.0191 17 12C17 9.23858 14.7614 7 12 7C10.9809 7 10.033 7.30488 9.24261 7.8284L16.1716 14.7574ZM7.8284 9.24261L14.7574 16.1716C13.967 16.6951 13.0191 17 12 17C9.23858 17 7 14.7614 7 12C7 10.9809 7.30488 10.033 7.8284 9.24261ZM12 5C8.13401 5 5 8.13401 5 12C5 15.866 8.13401 19 12 19C15.866 19 19 15.866 19 12C19 8.13401 15.866 5 12 5Z'
    ),
  ],
});

export enum DeliverySatus {
  Packed = 1,
  InTransit = 2,
  Delivered = 4,
  Cancelled = 6,
  Returned = 8,
}
const getDeliveryIcon = (
  status: number | string
): Pick<SVGIconDetail, 'shapes' | 'viewBoxSize'> => {
  switch (status) {
    case DeliverySatus.Packed:
      return packedIconDetail();
    case DeliverySatus.InTransit:
      return inTransitIconDetail();
    case DeliverySatus.Delivered:
      return deliveredIconDetail();
    case DeliverySatus.Returned:
      return returnedIconDetail();
    case DeliverySatus.Cancelled:
      return cancelledIconDetail();
  }

  // return BiError;

  return notFoundSVGIcon();
};

export const getDeliveryIconSet = (): SVGIconDetail[] =>
  getNumericObjectValues(DeliverySatus).map((value) => ({
    value,
    ...getDeliveryIcon(value),
  }));
